import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import { Button } from '@elements/button';
import { Icon } from '@elements/icon';
import { Container } from './dropzone.styles';
import check from '@images/check.svg';
import uploadFile from '@images/uploadFile.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Dropzone component.
 *
 * @author Ihar Kazlouski
 * @function Dropzone
 * @category elements
 * @param {DropzoneProps}
 * @return {FC} Dropzone component.
 */
var Dropzone = function Dropzone(_ref) {
  var supportedFormatName = _ref.supportedFormatName,
      getRootProps = _ref.getRootProps,
      getInputProps = _ref.getInputProps,
      acceptedFiles = _ref.acceptedFiles,
      open = _ref.open,
      isDragActive = _ref.isDragActive,
      maxSize = _ref.maxSize;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isFileUploaded = !!acceptedFiles.length;
  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, getRootProps({
    isDragActive: isDragActive
  })), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsxs(Grid, {
      container: true,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Grid, {
        item: true,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(Icon, {
          src: !isFileUploaded ? uploadFile : check,
          width: 32,
          height: 32
        })
      }), /*#__PURE__*/_jsx(Grid, {
        item: true,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        pt: 2,
        children: isFileUploaded ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "comet",
            fontWeight: "500",
            children: t('common.dropzone.containerAdded')
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            color: "comet",
            fontWeight: "500",
            textAlign: "center",
            children: acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles[0].name
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Typography, {
            pb: 1.5,
            variant: "body1",
            color: "comet",
            fontWeight: "500",
            children: t('common.dropzone.dropFile')
          }), /*#__PURE__*/_jsxs(Typography, {
            variant: "body3",
            color: "raven",
            children: [t('common.dropzone.supportedFormat'), " .", supportedFormatName]
          })]
        })
      }), /*#__PURE__*/_jsxs(Grid, {
        item: true,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        pt: 4,
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "contained",
          onClick: open,
          size: "small",
          children: !isFileUploaded ? t('common.dropzone.chooseFile') : t('common.dropzone.replace')
        }), /*#__PURE__*/_jsxs(Typography, {
          variant: "body3",
          color: "raven",
          pt: 1,
          children: [t('common.dropzone.maxSize'), " ", maxSize / 1048576, "MB"]
        })]
      })]
    })]
  }));
};

export { Dropzone };